import moment from 'moment';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'common/ui/tooltip';
import { cn } from 'utils/cn';
import { formatDateTime } from 'utils/formatDate';

// The backend only flips `is_online` back to false on an explicit logout call
// (see InternalAccountController.Logout in investcore). Clients that crash,
// get force-quit, or lose connectivity never fire that call, so the flag can
// stay stuck "online" forever. Treat it as stale once it's older than the
// user access token TTL (USER_TOKEN_EXPIRED_HOUR = 24h in investcore) since
// the session backing that flag can no longer be valid past that point.
const ONLINE_STALE_THRESHOLD_HOURS = 24;

function OnlineTooltip({
  lastLoginAt,
  isOnline,
  minimal,
}: {
  lastLoginAt: string,
  isOnline: boolean,
  minimal?: boolean,
}) {
  const effectiveIsOnline =
    !!isOnline &&
    !!lastLoginAt &&
    moment().diff(moment(lastLoginAt), 'hours') < ONLINE_STALE_THRESHOLD_HOURS;

  if (minimal) {
    if (!effectiveIsOnline) {
      return null;
    }
  }
  if (!lastLoginAt) {
    return null;
  }
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex max-w-fit items-center gap-1 transition-colors">
            <div className="relative size-2.5">
              {effectiveIsOnline ? (
                <div className="absolute inset-0 m-auto size-2.5 animate-ping items-center justify-center rounded-full group-hover:animate-none bg-green-500"></div>
              ) : null}
              <div
                className={cn(
                  'absolute inset-0 z-10 m-auto size-2.5 rounded-full',
                  effectiveIsOnline ? 'bg-green-400' : 'bg-yellow-400'
                )}
              />
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent className="font-normal">
          {
            <div>
              <div>Đăng nhập lần cuối:</div>
              <div>{formatDateTime(lastLoginAt)}</div>
            </div>
          }
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default OnlineTooltip;
